import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  Table,
  FilterBuilder,
  FieldType,
  Flex
} from 'onefaceui-react-components';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';

import queryClient from 'react/services/queryClient';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch';
import { getResourceTo } from 'react/utils/utils';

import { usePaymentMethodType } from 'react/queries/PaymentMethodType';
import { Container } from './PaymentMethodTypeStyles';
import EditIcon from 'static/images/monet/edit.svg';
import { getCriteriaChain } from 'react/utils/criteriaChainUtils';

export function PaymentMethodTypeList() {
  const dispatch = useDispatch();
  const tableRef = useRef(null);
  const [filters, setFilters] = useState({});

  const filterBuilderFields = [
    {
      id: 'key',
      label: getResourceTo('paymentmethodtype.field.key'),
      name: 'key',
      type: FieldType.TEXT
    }
  ];

  const criteriaChain = getCriteriaChain(filters, filterBuilderFields, false);

  const {
    data = [],
    isFetching,
    refetch
  } = usePaymentMethodType(criteriaChain);

  const tableColumns = [
    {
      title: getResourceTo('paymentmethodtype.field.key'),
      field: 'key'
    }
  ];

  const deleteItem = async (idList) => {
    tableRef.current?.setLoading(true);

    await defaultFetch('PaymentMethodType/BatchDelete', idList, 'POST');
    queryClient.setQueryData(['payment-method-type'], (dataCache) =>
      dataCache.filter((item) => !idList.includes(item.id))
    );

    tableRef.current?.setLoading(false);
  };

  const handleClickDelete = (values) => {
    const idsList = values.map(({ id }) => id);
    new Greenmile.Components.AlertModal(
      'Greenmile.Grid.BatchDelete.confirmDeletion',
      'Greenmile.Grid.BatchDelete.confirmDeletion.header',
      () => deleteItem(idsList),
      null,
      {
        isADeleteAction: true
      }
    ).show();
  };

  const tableActions = useMemo(() => {
    const actions = {
      customizeColumns: false
    };

    if (Monet.Security.checkKeyIsEnabled(['PAYMENTMETHODTYPE_CREATE'])) {
      actions.create = () => {
        dispatch(push('/PaymentMethodType/new'));
      };
    }

    if (Monet.Security.checkKeyIsEnabled(['PAYMENTMETHODTYPE_DELETE'])) {
      actions.delete = (values) => {
        if (values.length) handleClickDelete(values);
      };
    }

    return actions;
  }, []);

  const tableCustomColumns = useMemo(() => {
    const columns = [];

    if (Monet.Security.checkKeyIsEnabled(['PAYMENTMETHODTYPE_UPDATE'])) {
      columns.push({
        width: 50,
        field: 'edit',
        frozen: true,
        headerSort: false,
        hozAlign: 'center',
        formatter() {
          return `<img src=${EditIcon} class="edit-icon" alt="Edit Icon" />`;
        },
        cellClick(_, cell) {
          const { id } = cell.getRow().getData();
          dispatch(push(`/PaymentMethodType/edit/${id}`));
        }
      });
    }

    return columns;
  }, []);

  useEffect(() => {
    refetch();
  }, [filters]);

  return (
    <Container data-testid="payment-method-type-list">
      <FilterBuilder
        defaultSelected={['key']}
        onSubmit={(values) => setFilters(values)}
        fields={filterBuilderFields}
      />
      <Flex className="oneface-table-container">
        <Table
          isLoading={isFetching}
          ref={tableRef}
          defaultData={data}
          headerOptions={{
            showResults: true,
            actions: tableActions
          }}
          customColumns={tableCustomColumns}
          columns={tableColumns}
        />
      </Flex>
    </Container>
  );
}
